import { Vue } from 'vue-property-decorator';

Vue.directive('title', {
    inserted: (el, binding) => (document.title = `Joey - ${binding.value}`),
    update: (el, binding) => (document.title = `Joey - ${binding.value}`)
});
